import type { ReactNode } from 'react';

export const symbol_gite: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-200q-24.75 0-42.37-17.63Q80-235.25 80-260v-281q0-12.44 5-23.72T98-584l118-118q8-8 19.28-13 11.28-5 23.72-5h35v-50q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v50h347q12.44 0 23.72 5T744-702l118 118q8 8 13 19.28 5 11.28 5 23.72v281q0 24.75-17.62 42.37Q844.75-200 820-200H140Zm500-60h180v-281l-90-90-90 90v281Zm-60 0v-240H140v240h440Z"
		/>
	</svg>
);
